import { makeRequest } from '../../../api';

export const createInvite = (number) => makeRequest({
  url: '/sebTariff/createInvite',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  method: 'post',
  data: {
    ctn: number,
  },
});
